export default {
    login: {
        "intelligentIoTManagementPlatform": "Intelligent IoT Management Platform",
        "Username": "Username",
        "Password": "Password ",
        "code": "code",
        "login": "Login",
        "pleaseEnterUsername": "Please enter username",
        "pleaseEnterPassword": "Please enter password",
        "pleaseEnterCode": "Please enter verification code",
        "nickname": "nickname",
        "Loginaccount": "Login account",
        "superadministrator": "super administrator",
        "Salesman": "Salesman",
        "user": "user"
    },
    home: {
        "Numberofusers": "Number of users",
        "mandatoryDistribution":"Mandatory distribution",
        "Invalidated": "Invalidated",
        "total": 'Total number of terminals',
        "deviceTotal": 'Total',
        "SmartLock": 'Smart lock',
        "Bindingquantity": "Binding quantity",
        "OfflineDevices": 'Offline',
        "AbnormalDevices": 'Abnormal',
        "FaultyDevice": 'Faulty device',
        "OnlineDevice": 'Online device',
        "dataStatisticsAnalysis": "Data statistics and analysis",
        "oneClickAlarm": "One-click alarm",
        "infraredAlarm": "Infrared alarm",
        "totalDeviceAlarms": "Total alarms",
        "Numberofalarms": "Number of alarms",
        "Lowbatteryquantity": "Low battery quantity",
        "vacantRestroom": "Vacant restroom",
        "manholeCoverAnomaly": "Manhole anomaly",
        "totalEnergyConsumption": "electricity",
        "totalWaterConsumption": "water",
        "overflowingTrashBin": "Overflowing",
        "poorAirQuality": "Poor air",
        "temperatureHumidityAnomaly": "Temperature/humidity anomaly",
        "times": "times",
        "pieces": "pieces",
        "grasp": "grasps",
        "peoples": "peoples",
        "lockOpenTimes": "weekly number of lock openings",
        "businessManagementData": "Business management data",
        "totalNumberOfUsers": "total users",
        "totalNumberOfRooms": "Total number of rooms",
        "totalUnlockingTimes": "Total unlocking times",
        "TotalNumberOfLocksOpendToday": "Total number of locks opend today",
        "totalNumberOfDeviceAlarms": "device alarms",
        "numberOfDoorsOpened": "doors opened",
        "numberOfDoorsClosed": "doors closed",
        "totalRechargeAmount": "total recharge amount",
        "weeklyNewDevices": "New Equipment",
        "devicePowerAnalysis": "device power analysis",
        "powerLevel": "power level",
        "numbs": "number",
        "trillion": "trillion",
        "Billion": "billion",
        "tenThousand": "K",
        "doorLockOverview": "door lock overview",
        "lateReturnCount": "Late Returns",
        "totalProjectCount": "Total number of projects",
        "LateReturnees":"Late returnees",
        "totalRoomCount": "Total Rooms",
        "totalUserCount": "Total Users",
        "totalUnlockCount": "Total Unlocks",
        "usedDoorLocks": "Used Door Locks",
        "unusedDoorLocks": "Unused Door Locks",
        "lowBatteryWarning": "Low Battery Warnings",
        "fingerprintErrorWarning": "Fingerprint Error Warnings",
        "passwordErrorWarning": "Password Error Warnings",
        "passwordUnlock": "Password Unlocks",
        "fingerprintUnlock": "Fingerprint Unlocks",
        "Mechanicalkeyunlocking": "Mechanical key unlocking",
        "nfcUnlock": "NFC Unlocks",
        "bluetoothUnlock": "Bluetooth Unlocks",
        "keyUnlock": "Key Unlocks",
        "idCardUnlock": "ID Card Unlocks",
        "NBunlocking": "NB unlocking",
        "Unlockthenumerickeypad": "Unlock the numeric keypad",
        "unlockRecords": "Unlock Records",
        "fingerprint": "Fingerprint",
        "digitalKeypad": "Digital Keypad",
        "mechanicalKey": "Mechanical Key",
        "bluetooth": "Bluetooth",
        "idCard": "ID Card",
        "pinCode": "PIN Code",
        "face": "Face",
        "device": "device",
        "name": "name",
        "userTelephone": "user telephone",
        "roomName": "room Name",
        "Devicestatus": "Device status",
        "openType": "open type",
        "checkInStatisticsAnalysis": "check-in Statistics Analysis",
        "unlockCountStatistics": "Unlock Count Statistics for Current Day Time Interval",
        "LockPlatform": "Lock Platform",
        "Equipmenttype": "Equipment type",
        "empty": "empty",
        "signalintensity": "signal intensity",
      "gateway":"gateway",
        "AlarmLog": "Alarm Log",
        "Wirelesskeyunlocking": "Wireless key unlocking",
        "Faceunlock": "Face unlock",
        "Offlinecardunlocking": "Offline card unlocking",
        "Offlinepasswordunlocking": "Offline password unlocking",
        "Otherunlocking": "Other unlocking",
        "SynchronizeUpdates": "Synchronize Updates",
        "Numberofalarmstoday": "Number of alarms today"
    },
    room: {
        "campus": 'campus',
        "roomManagement": "room management",
        "voucherManagement":"voucher management",
        "exportListing": "export listing"
    },
    checkIn: {
        "certificateName":"Certificate name",
        "remarkText249": "Total number of partitioned projects",
        "Currentpartition": "Current partition",
        "Modifypermission": "Modify permission",
        "personnelTermination":"personnel termination",
        "personnelLeaseExtension":"personnel lease extension",
        "roomSelection": "roomSelection",
        "personnelRegistration": "personnelRegistration",
        "voucherEntry": "voucherEntry",
        "addPersonnelInfoToRoom": "addPersonnelInfoToRoom",
        "nextStep": "next",
        "occupiedPersonnelInfo": "occupiedPersonnelInfo",
        "name": "name",
        "campusCardNo": "campus",
        "physicalCardNo": "physical",
        "identity": "identity",
        "department": "department ",
        "checkInTime": "checkInTime",
        "checkOutTime": "checkOutTime",
        "gender": "gender",
        "malefemale": "1 is male, 2 is female",
        "NFCPassword": "3 is NFC, 4 is password",
        "remark": "remark",
        "phoneNumber": "phoneNumber",
        "digitphonenumber": "11 digit phone number",
        "leaseTerm": "leaseTerm",
        "operation": "operation",
        "personnelVoucher": "personnelVoucher",
        "enteredVoucherInfo": "enteredVoucherInfo",
        "pendingVoucher": "pendingVoucher",
        "roomNumber":"roomNumber",
        "terminationOfLease":"termination of lease",
        "room":'room',
        "systemNumber":"system number",
        "idCard":"ID card",
        "startTime":"start time",
        "endTime":"end time",
        "allRooms":"all rooms",
        "guests":"guests",
        "numberOfVouchers":"number of vouchers",
        "noShow":"no-show",
        "normal":"normal",
        "reportthelossof": "report the loss of",
        "preaccountopening": "Pre account opening",
        "expire": "expire",
        "company":"company",
        "remarkText":"Each line of data is color-coded as follows:\n" +
            "Green background indicates that the issued instructions for the voucher have been successfully dispatched.\n" +
            "Yellow indicates that the issued instructions for the voucher are still being dispatched.\n" +
            "Red indicates that the issued instructions for the voucher have failed to be dispatched.",
        "pleaseselectanidentity": "Please select an identity",
        "remarkText2": "11 digit unique identification, such as 20220810104",
        "bindRoom": "bind room",
        "batchRenew": "batch renew",
        "batchCheckout": "batch check out",
        "issueVoucher": "issue voucher",
        "serialNumber": "ID",
        "studentID": "student ID",
        "cardnumber": "card number",
        "male": "male",
        "female": "female",
        "doorcardstatus": "door card status",
        "cardstatus": "card status",
        "pleaseselect": "Please select",
        "createanaccount": "create an account",
        "vouchername": "Voucher Name",
        "SelectStartDateTime": "Select Start Date Time",
        "SelectEndDateTime": "Select End Date Time",
        "freeze": "freeze",
        "switchboxdisplay": "Switch box display",
        "SwitchTableDisplay": "Switch Table Display",
        "noneroom": "There is currently no housing available",
        "peoplename": "Personnel Name",
        "to": "to",
        "Selectabindingroom": "Select a binding room",
        "unbind": "Unbind",
        "renewaloflease": "renewal of lease",
        "addavoucher": "Add a voucher",
        "selectthetype": "Please select the type",
        "vouchertype": "Voucher type",
        "VoucherValidity": "Voucher Validity",
        "createdtime": "Created time",
        "batchissuance": "batch issuance",
        "ModifyVoucher": "Modify Voucher",
        "distributionrecord": "View the distribution record",
        "Deleteplatformrecords": "Delete platform records",
        "type": "type",
        "Uploadphotos": "Upload photos",
        "leftthumb": "left thumb",
        "rightindexfinger": "right index finger",
        "leftindexfinger": "left index finger",
        "rightthumb": "right thumb",
        "CollectingFingerprintsZH": "GX1000-zh collecting fingerprints",
        "CollectingFingerprintsLWJ": "LWJ collects fingerprints",
        "enterthecontent": "Please enter the content",
        "NFCcardnumber": "NFC card number",
        "enterthedevicenumber": "Please enter the device number",
        "entertheIMEInumber": "Please enter the IMEI number",
        "selectthecorrespondingroom": "Please select the corresponding room",
        "selectthedistributionstatus": "Please select the distribution status",
        "Issuedsuccessfully": "Issued successfully",
        "Waittosend": "Wait to send",
        "Issuing": "Issuing",
        "Sendingfailed": "Sending failed",
        "Invalidated": "Invalidated",
        "Lockendcredentialtype": "Lock end credential type",
        "lockendcertificate": "Validity period of lock-end certificate",
        "Distributionstatus": "Distribution status",
        "Reissue": "Reissue",
        "batchupload": "batch upload",
        "ImportExcel": "Import Excel",
        "DownloadTemplate": "Download Template",
        "Checkinroom": "Check in room",
        "Thecontent": "The content",
        "ThecontentNFCpassword": "NFC is an 8-digit hexadecimal physical card number, and the password is a 6-digit numerical password",
        "periodofvalidity": "period of validity",
        "enteryourname": "Please enter your name",
        "remarkText3": "The minimum time cannot be less than or greater than this time range",
        "selectthevouchertype": "Please select the voucher type",
        "enterthevouchername": "Please enter the voucher name",
        "pleaseenter": "Please enter ",
        "Other": "Other",
        "Freezeuser": "Freeze user",
        "remarkText4": "Whether to freeze the locked user?",
        "remarkText5": "Whether to unfreeze the locked user?",
        "remarkText6": "Whether to freeze these locked users?",
        "remarkText7": "Whether to unfreeze these locked users?",
        "remarkText8": "Whether to terminate the lease?",
        "remarkText9": "This operation will extend the check-in time.  Do you want to continue?",
        "remarkText10": "Please select the time range",
        "remarkText11": "No corresponding device found",
        "remarkText12": "Are you sure to delete the platform record?",
        "remarkText13": "This operation will delete the locked voucher, please confirm!",
        "remarkText14": "No corresponding fingerprint serial number found",
        "remarkText15": "No corresponding device found",
        "remarkText16": "Failed to obtain the lock information corresponding to the room",
        "remarkText17": "Successfully deleted the corresponding voucher for the person",
        "remarkText18": "Failed to delete the corresponding voucher for the person",
        "remarkText19": "Please check the data to be deleted",
        "remarkText20": "Are you sure to delete?",
        "remarkText21": "Whether to continue to stay?",
        "remarkText22": "The room is not bound with a door lock",
        "remarkText23": "Please select the room to add",
        "remarkText24": "User door lock already exists",
        "remarkText25": "Card format error, please re-enter",
        "remarkText26": "Password cannot be empty",
        "remarkText27": "Do you want to cancel the rental of the checked in room first?",
        "remarkText28": "Please fill in the complete information",
        "remarkText29": "Please fill in the correct phone number",
        "remarkText30": "Successfully created account",
        "remarkText31": "Failed to create account",
        "remarkText32": "Please select the department you belong to",
        "remarkText33": "Please select a fingerprint alias",
        "remarkText34": "Password length is 6 digits",
        "remarkText35": "Are you sure you want to resend it?",
        "remarkText36": "This device was not found",
        "remarkText37": "Do you want to only terminate the platform relationship and not delete locked users?",
        "remarkText38": "Card writing error, please check if the card reader is functioning properly!",
        "remarkText39": "Card reading error, please check if the card reader is functioning properly!",
        "remarkText40": "The room is currently distributing this user and cannot be deleted!",
        "remarkText41": "Successfully deleted user",
        "remarkText42": "Failed to delete user",
        "remarkText43": "Unbind the room successfully",
        "remarkText44": "Failed to unbind the room",
        "remarkText45": "No corresponding locked voucher record found",
        "remarkText46": "Card format error, delete and re-enter",
        "remarkText47": "Unable to find the corresponding credential ID on the lock",
        "remarkText48": "This operation will delete the voucher record. Please confirm!",
        "remarkText49": "Please delete the locked voucher first",
        "remarkText50": " format error",
        "remarkText51": "Batch does not support fingerprints",
        "remarkText52": "The corresponding door lock was not found in the room",
        "tips": "tips",
        "Freezinginstruction": "Freezing instruction ",
        "thawinginstruction": "thawing instruction ",
        "Failedtoissue": "Failed to issue",
        "selectthestartandendtime": "Please select the start and end time",
        "Freezeandlockusers": "Freeze and lock users in batches",
        "Modificationfailed": "Modification failed",
        "Modificationsuccessful": "Modification successful",
        "alreadyexists": " already exists",
        "Deletingsuccessfully": "Deleting successfully",
        "Failedtodelete": "Failed to delete",
        "Deleting": "Deleting",
        "Undermodification": "Under modification",
        "Studentcardinformation": "Student card information",
        "Addingfailed": "Adding failed",
        "Addingsuccessfully": "Adding successfully",
        "Operationsuccessful": "Operation successful",
        "Operationfailed": "Operation failed",
        "Unbindsuccessfully": "Unbind successfully",
        "Unbindfailed": "Unbind failed",
        "PersonnelImportTemplate": "Personnel Import Template",
        "Bindingsuccessful": "Binding successful",
        "Bindingfailed": "Binding failed",
        "Removed": "Removed",
        "unknown": "unknown",
        "offline": "off-line",
        "online": "on line",
        "abnormal": "abnormal",
        "search": " search",
        "DeviceName": "Device Name",
        "whole": "whole",
        "Expired": "Expired",
        "uninitialized": "uninitialized",
        "initialization": "initialization",
        "BindingStatus": "Binding Status",
        "Bound": "Bound",
        "Unbound": "Unbound",
        "Versionnumber": "Version number",
        "remarkText53": "Select the start time for device launch",
        "SelectEndTime": "Select End Time",
        "signal": "signal",
        "Doorlockoperation": "Door lock operation",
        "Temporarypassword": "Temporary password",
        "Remoteunlocking": "Remote unlocking",
        "Removeallpasswords": "Remove all passwords",
        "DeleteallNFCs": "Delete all NFCs",
        "DeleteallFps": "Delete all fingerprints",
        "Resetdoorlock": "Reset door lock",
        "Onlinestatus": "Online status",
        "Registrationtime": "Registration time",
        "Launchtime": "Launch time",
        "Remoteunlockingpassword": "Remote unlocking password",
        "Administratorpassword": "Administrator password",
        "model": "model",
        "SupertubeID": "Supertube ID",
      "IMSI": "IMSI",
        "Operator": "Operator",
        "SupertubeName": "Supertube Name",
        "Supertubepassword": "Supertube password",
        "Customercode": "Customer code",
        "Connectionmethod": "Connection method",
        "Directconnection": "Direct connection",
        "SelectRoom": "Select Room",
        "Deviceverificationcode": "Device verification code",
        "Doorlockdetails": "Door lock details",
        "volume": "volume",
        "Mute": "Mute",
        "bass": "bass",
        "Treble": "Treble",
        "Normallyopensetting": "Normally open setting",
        "Normallyopenstate": "Normally open state",
        "Datasynchronization": "Data synchronization",
        "Selectstarttimeperiod": "Select start time period",
        "SelectEndTimePeriod": "Select End Time Period",
        "ConfirmSettings": "Confirm Settings",
        "Unset": "Unset",
        "StartingMonth": "Starting Month",
        "EndMonth": "End Month",
        "Operationlog": "Operation log",
        "VoucherRecord": "Voucher Record",
        "BatchSetNormallyOpen": "Batch Set Normally Open",
        "Starttimeperiod": "Start time period",
        "Endtimeperiod": "End time period",
        "MACaddress": "MAC address",
        "Appbindingnumber": "App binding number",
        "Productionwritenumber": "Production write number",
        "remarkText54": "Emergency password, can only be used once a day",
        "remarkText55": "Recent signal curve of door lock",
        "remarkText56": "Recent power curve of the door lock",
        "signalcurve": "signal curve",
        "Time": "Time",
        "doorlocksignal": "door lock signal",
        "electricitycurve": "electricity curve",
        "Doorlockpower": "Door lock power",
        "today": "today",
        "Lastweek": "Last week",
        "Thismonth": "This month",
        "Thisyearsofar": "This year so far",
        "Lastsixmonths": "Last six months",
        "Close": "Close",
        "Inthemiddle": "In the middle",
        "Highly": "Highly",
        "Telecommunications": "Telecommunications",
        "Move": "Move",
        "Unicom": "Unicom",
        "Listofdoorlocks": "List of door locks",
        "Dataerror": "Data error",
        "remarkText57": "Whether to unfreeze the door lock?",
        "remarkText58": "Whether to freeze the door lock?",
        "Resetsuccessfully": "Reset successfully",
        "Initializationsucceeded": "Initialization succeeded",
        "Initializationfailed": "Initialization failed",
        "remarkText59": "Are you sure to synchronize data?",
        "Nodataavailable": "No data available",
        "remarkText60": "This room has been locked, please choose again",
        "Sentsuccessfully": "Sent successfully",
        "Acquisitionsucceeded": "Acquisition succeeded",
        "Failedtoobtain": "Failed to obtain",
        "remarkText61": "Please check the devices to be added in batch",
        "Setsuccessfully": "Set successfully",
        "Settingfailed": "Setting failed",
        "remarkText62": "Please select the correct starting time period",
        "remarkText63": "Please select the correct end time period",
        "remarkText64": "This setting is not supported for this type of lock!",
        "Open": "Open",
        "remarkText65": "Are you sure to reset the door lock?",
        "remarkText66": "Are you sure to delete all cards?",
        "remarkText661": "Are you sure to delete all fingerprints?",
        "remarkText67": "Are you sure to delete all passwords?",
        "remarkText68": "Are you sure to open the door remotely?",
        "remarkText69": "Unlocking succeeded!",
        "remarkText70": "Failed to unlock!",
        "remarkText71": "Please select initialization device",
        "remarkText72": "Are you sure to initialize in batch?",
        "remarkText73": "Are you sure to initialize?",
        "remarkText74": "Registration successful",
        "remarkText75": "Registration failed, please try again later",
        "remarkText76": "Are you sure to unlock in batch?",
        "remarkText77": "Are you sure to unbind?",
        "remarkText78": "Import template for device",
        "Eachpage": "Each page",
        "strip": "strip",
        "AddAccount": "Add Account",
        "Adddepartment": "Add department",
        "HistoricalAccount": "Historical Account ",
        "Usertype": "User type",
        "role": "role ",
        "Changepassword": "Change password",
        "Oldpassword": "Old password",
        "Newpassword": "New password",
        "Createdepartment": "Create department",
        "Affiliatedinstitution": "Affiliated institution",
        "Departmentname": "Department name",
        "Allowaccess": "Allow access",
        "coordinate": "coordinate",
        "Editingdepartment": "Editing department",
        "ModifyName": "Modify Name",
        "housingresources": "housing resources",
        "selectaddress": "select address",
        "Lockpryingalarm": "Lock prying alarm",
        "Forceddooropeningalarm": "Forced door opening alarm",
        "Lowbatteryalarm": "Low battery alarm",
        "Duressunlockingalarm": "Duress unlocking alarm",
        "RechargeSMS": "Recharge SMS",
        "Successfullypaidtherent": "Successfully paid the rent",
        "Remindertopayrent": "Reminder to pay rent",
        "Successfullysignedthecontract": "Successfully signed the contract",
        "SeniorAdministrator": "Senior Administrator",
        "Intermediateadministrator": "Intermediate administrator",
        "Lowleveladministrator": "Low level administrator",
        "administrators": "administrators",
        "Subusers": "Sub users",
        "AppletUser": "Applet User",
        "Name": "name",
        "remarkText79": "11 characters in length",
        "remarkText80": "Are you sure to delete the corresponding account of the department?",
        "Accountdeletedsuccessfully": "Account deleted successfully",
        "Accountdeletionfailed": "Account deletion failed",
        "remarkText81": "Please select the department to edit",
        "remarkText82": "Please enter the number of allowed access devices",
        "Createdsuccessfully": "Created successfully",
        "Creationfailed": "Creation failed",
        "Exceedingquota": "Exceeding quota",
        "remarkText83": "Confirm password input error!",
        "remarkText84": "Please enter the modified password",
        "AddRole": "Add Role",
        "rolename": 'role name',
        "classification": "classification",
        "SaveSettings": "Save Settings",
        "Defaultpermissions": "Default permissions",
        "yes": "yes",
        "no": 'no',
        "Option1": "Option1",
        "Option2": "Option2",
        "Updatesuccessful": "Update successful",
        "Updatefailed": "Update failed",
        "DefaultRole": "Default Role",
        "Operationmodule": "Operation module",
        "Operationpath": "Operation path",
        "Requesttype": "Request type",
        "Operationdescription": "Operation description",
        "Operationmethod": "Operation method",
        "Requestparameters": "Request parameters",
        "Returnparameters": "Return parameters",
        "Requestpath": "Request path",
        "Operationtime": "Operation time",
        "Detailedinformation": "Detailed information",
        "Exceptionlog": "Exception log",
        "Errormessage": "Error message",
        "Wrongname": "Wrong name",
        "Alarmtype": "Alarm type",
        "Alarmtime": "Alarm time",
        "Dooropeningmethod": "Door opening method",
        "remarkText85": "Trial and error unlocking of door card",
        "Unlockingtime": "Unlocking time",
        "remarkText86": "Data is more than 10,000, unable to export",
        "Setpersonnel": "Set personnel",
        "SetStatus": "Set Status",
        "Settime": "Set time",
        "remarkText87": "Date range",
        "remarkText88": "Time period",
        "Lockuser": "Lock user",
        "Operatorpersonal": "Operator",
        "Operationtype": "Operation type",
        "CommandStatus": "Command Status",
        "Issuingtimeout": "Issuing timeout",
        "serialnumber": "serial number",
        "remarkText89": "No corresponding door lock found, operation failed",
        "remarkText90": "No corresponding voucher record found, operation failed",
        "remarkText91": "Re-issue?",
        "remarkText92": "Please enter the campus name",
        "remarkText93": "Please select a specific address",
        "remarkText94": "Number of occupants",
        "remarkText300":"Is it mandatory to issue!",
        "Address": "Address",
        "Typeofapartment": "Type of apartment",
        "singleroom": "single room",
        "room1": "one bedroom and one living room",
        "room2": "two rooms and one living room",
        "room3": "three rooms and one living room",
        "Area": "Area",
      "codeNumber": "code",
        "tenant": "tenant",
        "remarkText95": "Create individually",
        "remarkText96": "Please enter a number",
      "remarkText999": "code",
        "Sorting": "Sorting",
        "isRoom": "Is it a room?",
        "Templatecreation": "Template creation",
        "Levelname": "Level name",
        "remarkText97": "For example: dormitory area, dormitory building, building unit, floor, room, multiple separated by ', '",
        "Numberoflevels": "Number of levels",
        "remarkText98": "Please enter the corresponding number of levels, separated by a ', ' for multiple levels",
        "Singleaddition": "Single addition",
        "TemplateAddition": "Template Addition",
        "FloorLevel": "Floor Level",
        "remarkText99": "Please enter the number of rooms on the corresponding floor",
        "Numberofrooms": "Number of rooms",
        "remarkText100": "Please enter the apartment name",
        "Addhierarchy": "Add hierarchy",
        "Addroom": "Add room",
        "binding": "binding",
        "BindUser": "Bind User",
        "Unbind": "Unbind",
        "remarkText101": "Please select the property to export",
        "Apartment1": "Apartment 1",
        "Apartment2": "Apartment 2",
        "Building1": "Building 1",
        "Building2": "Building 2",
        "Unit1": "Unit 1",
        "Unit2": "Unit 2",
        "1stfloor": "1st floor",
        "2ndfloor": "2nd floor",
        "remarkText102": "The relationship between personnel and equipment will be deleted after deletion.  Are you sure you want to delete it?",
        "remarkText103": "The room is not bound with a door lock",
        "Dormitorysources": "Dormitory sources",
        "Housinginformation": "Housing information",
        "remarkText104": "Has reached the first level",
        "remarkText105": "The room cannot add subordinates",
        "remarkText106": "Please check the data that needs to be unbound",
        "remarkText107": "Please check the data that needs to be managed",
        "remarkText108": "Are you sure to bind?",
        "remarkText109": "The apartment name cannot be empty",
        "remarkText110": "The apartment unit name cannot be empty",
        "remarkText111": "The apartment floor cannot be empty",
        "remarkText112": "The number of apartment units and floors needs to correspond",
        "remarkText113": "Floor name cannot be empty",
        "remarkText114": "The number of rooms cannot be empty",
        "remarkText115": "Please select the voucher status",
        "Bluetoothbuckle": "Bluetooth buckle",
        "remarkText116": "No corresponding device found",
        "remarkText117": "Failed to query the device",
        "remarkText118": "The two password entries are inconsistent!",
        "remarkText119": "Please select to delete data!",
        "remarkText120": "Whether to delete the platform voucher!",
        "remarkText121": "This voucher has not been issued yet",
        "remarkText122": "Delete lock and platform records",
        "remarkText123": "The door lock was pried",
        "remarkText124": "Forcibly opening the door",
        "remarkText125": "Fingerprint attempt to unlock frozen",
        "remarkText126": "Password attempt to unlock frozen",
        "remarkText127": "Card attempt to unlock frozen",
        "remarkText128": "Key attempt to unlock frozen",
        "remarkText129": "Low battery alarm",
        "remarkText130": "reserve",
        "remarkText131": "Duress unlocking alarm",
        "remarkText132": "Forgot to remove the key",
        "remarkText133": "Knocking Reminder",
        "remarkText134": "SOS distress reminder",
        "remarkText135": "The door is not closed properly",
        "remarkText136": "The door has been unlocked",
        "remarkText137": "Door unlocked",
        "remarkText138": "Normally open",
        "remarkText139": "Other alarms",
        "remarkText140": "Low battery reminder",
        "Canceledsuccessfully": "Canceled successfully",
        "Cancelfailed": "Cancel failed",
        "Totalincome": "Total income",
        "Totalnumberofpeople": "Total number of people",
        "Signed": "Signed",
        "Totalnumberofresidentialareas": "Number of communities",
        "Totalnumberofrooms": "Number of rooms",
        "NumberofOccupations": "Number of Occupations",
        "Roominarrears": "Room in arrears",
        "Totalequipment": "Total equipment",
        "Totalnumberofexceptions": "number of exceptions",
        "Lowbatterycount": "Low battery count",
        "expiredequipment": "expired equipment",
        "roomoccupancyrate": "room occupancy rate",
        "rateofarrearsinroomcharges": "rate of arrears in room charges",
        "Checkininformation": "Unlock Today",
        "month": 'month',
        "Rentalincomeranking": "Rental income ranking（$）",
        "remarkText141": "Select check-in date and time",
        "remarkText142": "Select the date and time of the lease termination",
        "Selectdevice": "Select device",
        "Finished": "Finished",
        "Entering": "Entering",
        "capturecard": "GX1000-zh capture card",
        "Setpassword": "Set password",
        "Confirmpassword": "Confirm password",
        "remarkText143": "Please enter your name to search",
        "remarkText144": "Please enter your student number",
        "remarkText145": "This ID card already exists",
        "remarkText146": "This NFC card already exists",
        "remarkText147": "This Password card already exists",
        "remarkText148": "This fingerprint already exists",
        "remarkText149": "Please select the issuing voucher",
        "remarkText150": "This operation will issue the selected vouchers.  Do you want to continue?",
        "remarkText151": "Issuance has been canceled",
        "remarkText152": "The door lock is offline.  Please handle the offline issue first!",
        "remarkText153": "Please select the start and end time",
        "remarkText154": "ID number cannot be empty",
        "remarkText155": "NFC cannot be empty",
        "remarkText156": "Password cannot be empty",
        "remarkText157": "Please enter your fingerprint",
        "remarkText158": "The passwords you entered are different.  Please re-enter!",
        "Submittedsuccessfully": "Submitted successfully",
        "remarkText159": "Please select a room",
        "remarkText160": "Please select a voucher",
        "remarkText161": "Please bind the door lock first",
        "remarkText162": "Failed to obtain the door lock credentials",
        "remarkText163": "Please select the check-in and check-out time",
        "remarktext164": "Please bind the device first",
        "remarkText165": "This person already exists",
        "Checkin": "Check in",
        "remarkText166": "Length between 1 and 8 characters",
        "remarkText167": "Please enter the correct system number",
        "remarkText168": "Please enter the correct ID number number",
        "remarkText169": "Please select educational background",
        "remarkText170": "Please enter your email",
        "remarkText171": "Please enter the correct email",
        "remarkText172": "Please select the rental period",
        "remarkText173": "Please enter the rent",
        "remarkText174": "Please select the person who will terminate the lease",
        "remarkText175": "Are you sure to terminate the lease?",
        "remarkText176": "Lease cancellation successful",
        "remarkText177": "Failed to terminate the lease",
        "Leaseterminated": "Lease terminated",
        "remarkText178": "Please filter whether it is expired",
        "thaw": "thaw",
        "Normalroom": "Normal room",
        "vacantroom": "vacant room",
        "Freezepersonnel": "Freeze personnel",
        "remarkText179": "Please select thawing personnel",
        "remarkText180": "Are you sure you want to thaw?",
        "remarkText181": "Are you sure you want to freeze?",
        "Unitname": "Unit name",
        "remarkText182": "Please select the unit",
        "remarkText183": "Please enter the contact name",
        "remarkText184": "Please enter the contact's phone number",
        "Noticemethod": "Notice method",
        "Subordinateunit": "Subordinate unit",
        "textmessage": "text message",
        "officialaccount": "official account",
        "QuickActions": "Quick Actions",
        "Allocationquota": "Allocation quota",
        "Existinglimit": "Existing limit",
        "Allocableamount": "Allocable amount",
        "Policecall": "Police call",
        "Receivingtype": "Receiving type",
        "remarkText185": "Device not processing alarm records",
        "remarkText247": "Switching between single/multiple query modes",
        "Assignedsuccessfully": "Assigned successfully",
        "balance": "balance",
        "remarkText186": "Are you sure to modify it?",
        "remarkText187": "Name cannot be empty",
        "remarkText188": "Phone number cannot be empty",
        "generate": "generate",
        "Callbacktype": "Callback type",
        "CallbackURL": "Callback URL",
        "Userdatacallback": "User data callback",
        "Callbackofhousingdata": "Callback of housing data",
        "apartment": "apartment",
        "PingshanVillage": "Pingshan Village",
        "remarkText189": "Number of rooms in each community (rooms)",
        "remarkText190": "Number of newly added rooms (rooms)",
        "remarkText191": "Number of newly added rooms",
        "Tobesigned": "To be signed",
        "Arrears": "Arrears",
        "withdrawaloflease": "withdrawal of lease",
        "Numberofcontracts": "Number of contracts",
        "hasexpired": "has expired",
        "Signingstatus": "Signing status",
        "remarkText192": "Minimum rent",
        "remarkText193": "Highest rent",
        "Signacontract": "Sign a contract",
        "ContractNo": "Contract No",
        "Rent": "Rent/$",
        "ContractStatus": "Contract Status",
        "Deleted": "Deleted",
        "CreatedDate": "Created Date",
        "Freezeuserpermission": "Freeze user permission",
        "Previewcontract": "Preview contract",
        "remarkText194": "Fill in the information of the signer",
        "Certificatetype": "Certificate type",
        "CertificateNo": "Certificate No",
        "nativeplace": "native place",
        "Addressforcorrespondence": "Address for correspondence",
        "TenantCategory": "Tenant Category",
        "Subsidystandard": "Subsidy standard",
        "Addcoresident": "Add co-resident",
        "Information": "Information",
        "Deletethecohabitant": "Delete the cohabitant",
        "remarkText195": "Search for housing information",
        "remarkText196": "House address information",
        "Monthlyrent": "Monthly rent",
        "remarkText197": "Housing structure information",
        "RoomStatus": "Room Status",
        "remarkText198": "Fill in contract information",
        "remarkText199": "Selected room",
        "remarkText200": "Number of rooms inside the suite",
        "Signatory": "Signatory",
        "Passport": "Passport",
        "Paymentmethod": "Payment method",
        "Signingtime": "Signing time",
        "remarkText201": "Time of signing the contract",
        "remarkText202": "validity period of the contract",
        "Effectivetime": "Effective time",
        "Paymentdate": "Payment date",
        "remarkText203": "Whether to send dynamic temporary password",
        "remarkText204": "Enter unlock authorization",
        "remarkText205": "Is it a normally open card",
        "remarkText206": "time-sensitive password",
        "Lastmonth": "Last month",
        "Lastthreemonths": "Last three months",
        "Cashmoney": "Cash money",
        "Creditcard": "Credit card",
        "Alipay": "Alipay",
        "WeChat": "WeChat",
        "remarkText207": "One-time subsidy",
        "remarkText208": "Monthly subsidy",
        "remarkText209": "One time subsidy and monthly basic subsidy",
        "remarkText210": "Chinese Mainland",
        "remarkText211": "Compatriots from Hong Kong, Macao, and Taiwan",
        "remarkText212": "Foreign friends",
        "remarkText213": "The start time must not be greater than the end time",
        "tenancycontract": "tenancy contract",
        "Syncsuccessful": "Sync successful",
        "Synchronizationfailed": "Synchronization failed",
        "remarkText214": "Do you want to delete it first?",
        "remarkText215": "Please select payment method",
        "remarkText216": "Please enter the contract number",
        "remarkText217": "Please select the payment time",
        "remarkText218": "Please select the signing time",
        "remarkText219": "Please select an expiration date",
        "remarkText220": "Please select personnel",
        "remarkText221": "Please select the type of entry voucher",
        "remarkText222": "Notification successful",
        "remarkText223": "Notification failed",
        "remarkText224": "The person already has a contract, please reselect",
        "remarkText225": "The cohabitant has duplicate form information, please fill in the correct form information",
        "remarkText226": "Please fill in the signatory form information correctly",
        "remarkText227": "The room has not yet been bound with equipment. Please bind the equipment before check-in",
        "remarkText228": "Phone format error",
        "remarkText229": "ID number error",
        "remarkText230": "No personnel found",
        "remarkText231": "Start time and end time cannot be empty",
        "remarkText232": "The start time cannot exceed the ancestral agreement time",
        "remarkText233": "The end time cannot exceed the lease time",
        "remarkText234": "The voucher has been saved",
        "remarkText235": "The voucher already exists",
        "remarkText236": "Please select to batch delete contracts",
        "remarkText237": "Do you want to batch delete first?",
        "remarkText238": "Please select a batch lease termination contract",
        "remarkText239": "Do you want to cancel the lease in bulk first?",
        "remarkText240": "Do you want to cancel the lease first?",
        "remarkText241": "No corresponding room information found",
        "remarkText242": "Create a template",
        "remarkText243": "Template Name",
        "filename": "file name",
        "TemplateContent": "Template Content",
        "remarkText244": "This operation will delete the template. Do you want to continue?",
        "Uploadsuccessful": "Upload successful",
        "Uploadfailed": "Upload failed",
        "remarkText245": "Housing Lease Contract Template",
        "remarkText246": "Please select the person to renew the lease",
        "Renewalsuccessful": "Renewal successful",
        "Renewalfailed": "Renewal failed",
        "remarkText250": "Number of new devices added today",
        "remarkText248": "Current partition device proportion",
        "demonstrate": "demonstrate",
        "remarkText251": "The device number cannot be empty",
        "remarkText252": "The lock is not bound to a room, please bind the room first",
        "remarkText253": "Please select personnel first",
        "remarkText254": "Successfully bound personnel",
        "remarkText255": "Failed to bind personnel",
        "remarkText256": "Successfully issued voucher",
        "remarkText257": "Failed to issue voucher",
        "remarkText258": "Confirm Close？"
    },
    button: {
        "Exportcontract": "Export contract",
        "Synchronizecontractstatus": "Synchronize contract status",
        "Newlyadded": "Newly added",
        "query": "query",
        "reset": "reset",
        "add": "add",
        "Update": "Update",
        "back":"back",
        "modify": "modify",
        "cancel": "cancel ",
        "view": "view",
        "addSubordinate": "addSubordinate",
        "edit": "edit",
        "delete": "delete",
        "export": "export",
        "batchDelete": "batchDelete",
        "doorLock": "doorLock",
        "tenant": "tenant",
        "confirm": "confirm ",
        "selectAll":"select all",
        "RenewalRenting":"Renewal/Renting",
        "exportstudentcardinformation": "Export student card information",
        "batchcheck-in": "Batch check-in",
        "batchcheckExport": "batchcheck Export",
        "compareuploads": "Compare uploads",
        "AdvancedQuery": "Advanced Query",
        "AdvancedSearch": "Advanced Search",
        "ResetSearch": "Reset Search",
        "Adddevice": "Add device",
        "BatchAdd": "Batch Add",
        "Batchinitialization": "Batch initialization",
        "ExportList": "Export List",
        "Synchronizedeviceinformation": "Synchronize device information",
        "UnbindRoom": "Unbind Room",
        "Forceddeletion": "Forced deletion",
        "Save": "Save",
        "renewaloflease": "renewal of lease",
        "submit": "submit",
        "SameUseQuery": "Same Use Query",
      "synchronize": "synchronize"
    },
    menubar: {
        "datasummary": "data summary",
        "homepage": "home page",
        "Largescreendisplay": "Large screen display",
        "PropertyManagement": "Property Management",
      "Repair": "Repair",
        "Listingofproperties": "Listing of properties",
        "BusinessManagement": "Business Management",
        "Doorlockbusiness": "Door lock business",
        "Checkinprocessing": "Check-in processing",
        "Residencymanagement": "Residency management",
        "Survivalmanagement": "Survival management",
        "personnelmanagement": "personnel management",
        "PersonnelList": "Personnel List",
        "VoucherManagement": "Voucher Management",
        "InformationBase": "Information Base",
        "equipmentmanagement": "equipment management",
        "Doorlockequipment": "Door lock equipment",
        "Doormagneticequipment": "Door magnetic equipment",
        "Usermanagement": "User management",
        "Loginaccount": "Login account",
        "Rolepermissions": "Role permissions",
        "bindarole": "bind a role",
        "Logmanagement": "Log management",
        "Systemlogs": "System logs",
        "Doorlocklog": "Door lock log",
        "UnlockRecord": "Unlock Record",
        "WarningLog": "Warning Log",
        "DeviceFeedbackLog": "Device Feedback Log",
        "Doormagneticlog": "Door magnetic log",
        "Alarmlog": "Alarm log"
    },
    enmonth: {
        "Jan": "Jan",
        "Feb": "Feb",
        "Mar": "Mar",
        "Apr": "Apr",
        "May": "May",
        "Jun": "Jun",
        "Jul": "Jul",
        "Aug": "Aug",
        "Sep": "Sep",
        "Oct": "Oct",
        "Nov": "Nov",
        "Dec": "Dec",
    },
    singlePrice:{
        priceName:'price name',
        priceNum:'price number',
        status:'status',
        type:'type',
        price:'price',
        waterPrice:'WaterPrice/m³',
        electricityPrice:'ElectricityPrice/KW',
        waterPriceType:'Water price type',
        electricityPriceType:'Electricity price type'
    }
}



// WEBPACK FOOTER //
// ./src/utils/en.js